import React from 'react';
import { Key } from 'lucide-react';

/**
 * Dropdown menu row — opens change-password modal via onOpen from useChangePasswordModal().
 */
const ChangePasswordMenuItem = ({ onClose, onOpen, className, iconSize = 16 }) => {
  const defaultClassName =
    'w-full text-left px-3 py-2 text-sm text-[#0B2530] dark:text-gray-300 hover:bg-[#F8FCFB] dark:hover:bg-gray-700 rounded-md flex items-center gap-2';

  return (
    <button
      type="button"
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        onOpen?.();
        onClose?.();
      }}
      className={className || defaultClassName}
    >
      <Key size={iconSize} />
      Change Password
    </button>
  );
};

export default ChangePasswordMenuItem;
